﻿import { Offcanvas } from 'react-bootstrap';
import type { ReactNode } from 'react';

interface Props {
  show: boolean;
  onHide: () => void;
  title?: string;
  children: ReactNode;
  footer?: ReactNode;
  width?: number;
  placement?: 'start' | 'end';
}

export default function SidePanel({ show, onHide, title, children, footer, width = 1024, placement = 'end' }: Props) {
  return (
    <Offcanvas show={show} onHide={onHide} placement={placement} style={{ width }}>
      {title && (
        <Offcanvas.Header closeButton className="align-items-start py-3 pt-lg-4">
          <Offcanvas.Title>{title}</Offcanvas.Title>
        </Offcanvas.Header>
      )}
      <Offcanvas.Body className="d-flex flex-column gap-3 pt-2 pb-3">
        {children}
      </Offcanvas.Body>
      {footer && (
        <div className="offcanvas-footer border-top p-3 d-flex gap-2">
          {footer}
        </div>
      )}
    </Offcanvas>
  );
}
